/**
 * Hides fields one at a time, highest `dropOf` first, until `needsRoom` says the row fits.
 * Everything is shown again first, so a row that has grown gets back what it lost.
 * Returns the fields it hid, in the order it hid them.
 *
 * Kept apart from the component so the order of giving way is testable without a DOM.
 */
export const dropToFit = <T>(
  fields: T[],
  dropOf: (field: T) => number,
  show: (field: T) => void,
  hide: (field: T) => void,
  needsRoom: () => boolean
): T[] => {
  fields.forEach(show);
  const dropped: T[] = [];
  for (const field of [...fields].sort((a, b) => dropOf(b) - dropOf(a))) {
    if (!needsRoom()) break;
    hide(field);
    dropped.push(field);
  }
  return dropped;
};
